const development_tenant = {
    notification: 'คุณอยู่ในโหมดการพัฒนา',
};
export default Object.freeze(development_tenant);
